import { createFileRoute } from "@tanstack/react-router";

import { AdminGuard } from "@/components/admin/AdminGuard";
import { AdminSettingsPage } from "@/components/admin/settings/AdminSettingsPage";

export const Route = createFileRoute("/admin/settings")({
  component: AdminSettingsRoute,
});

function AdminSettingsRoute() {
  return (
    <AdminGuard>
      <AdminSettingsPage />
    </AdminGuard>
  );
}
